import Chyba from 'components/pages/Chyba';
import PopisSluzby from 'components/pages/lei/PopisSluzby';
import PrideleneLeiPrehled from 'components/pages/lei/PrideleneLeiPrehled';
import MainPage from 'components/pages/MainPage';
import BankidLogin from 'components/pages/nezarazenyUcet/BankidLogin';
import Zadost from 'components/pages/nezarazenyUcet/Zadost';
import VypisBankidLogin from 'components/pages/vypisZUctu/VypisBankidLogin';
import VypisZadost from 'components/pages/vypisZUctu/VypisZadost';
import BankidLoginNZ from 'components/pages/zapisNZ/BankidLoginNZ';
import PlatbaKoresp from 'components/pages/zapisNZ/PlatbaKoresp';
import ZapisZadost from 'components/pages/zapisNZ/ZapisZadost';
import routePathEnum from 'enums/routePathEnum';
import React from 'react';

interface IRouteMapa<T> {
    path: string; // Cesta vzata z enumu routePathEnum
    component: React.ComponentType<T>; // Componenty v route
    private?: boolean; // pouzit private = true pokud je potreba k pristupu token (prihlaseni)
}
const {
    MAIN_PAGE,
    CHYBA,
    VYPIS_BANKID_LOGIN,
    VYPIS_ZADOST,
    VYPIS_NU_BANKID_LOGIN,
    CHYBA_NU,
    CHYBA_NZ,
    VYPIS_NU_ZADOST,
    LEI_PREHLED_UCTU,
    LEI_POPIS_SLUZBY,
    ZAPIS_ZADOST,
    ZAPIS_ZADOST_BANKID_LOGIN,
    ZAPIS_ZADOST_NOVA,
    ZAPIS_ZADOST_PLATBA
} = routePathEnum;

/* Seznam URL rout a komponent na ně navázaných
 private routy jsou ty, které budou schované pod potřebným loginem, k ne-private lze přistupovat kdykoliv */
export function routeMapa<T>(): IRouteMapa<T>[] {
    return [
        {
            component: MainPage,
            path: MAIN_PAGE,
            private: true
        },
        {
            component: Chyba,
            path: CHYBA
        },
        {
            component: Chyba,
            path: CHYBA_NU
        },
        {
            component: Chyba,
            path: CHYBA_NZ
        },
        {
            component: VypisBankidLogin,
            path: VYPIS_BANKID_LOGIN
        },
        {
            component: BankidLogin,
            path: VYPIS_NU_BANKID_LOGIN
        },
        {
            component: VypisZadost,
            path: VYPIS_ZADOST
        },
        {
            component: PrideleneLeiPrehled,
            path: LEI_PREHLED_UCTU
        },
        {
            component: PopisSluzby,
            path: LEI_POPIS_SLUZBY
        },
        {
            component: Zadost,
            path: VYPIS_NU_ZADOST
        },
        {
            component: ZapisZadost,
            path: ZAPIS_ZADOST
        },
        {
            component: ZapisZadost,
            path: ZAPIS_ZADOST_NOVA
        },
        {
            component: BankidLoginNZ,
            path: ZAPIS_ZADOST_BANKID_LOGIN
        },
        {
            component: PlatbaKoresp,
            path: ZAPIS_ZADOST_PLATBA
        }
    ];
}
